@if(showSidebar){
  <app-sidebar></app-sidebar>
  <main class="app-main">
    <router-outlet></router-outlet>
  </main>
}@else{
  <router-outlet></router-outlet>
}
